import * as $ from "jquery";

$(function () {
    const $quotes = $(".quote-item");

    if ($quotes.length > 0) {
        let quoteIndex = -1;

        const showNextQuote = function () {
            ++quoteIndex;
            $quotes.eq(quoteIndex % $quotes.length)
                .fadeIn(1000)
                .delay(8000)
                .fadeOut(1000, showNextQuote);
        };

        showNextQuote();
    }
});
